export const baseHost = '/images'

export const version = '1.0'
// 进入比赛链接配置
export const exam_front_url = process.env.NODE_ENV === 'production' ? `http://${window.location.hostname}:8091` : 'http://192.168.1.41:8081'
